export default __webpack_public_path__ + "static/media/slider-2.a7f999fc.png";